let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dJFy4")).then(() => parcelRequire('eHc1t'));